import{a as t}from"./chunk-OTKIU24A.js";import{m as o}from"./chunk-HBP5N4FR.js";o();var r=e=>e.dappConfig,d=t(r,e=>e.shouldUseWebViewProvider);export{r as a,d as b};
//# sourceMappingURL=chunk-UH6MS3HS.js.map
